module.exports = __webpack_public_path__ + "static/img/radiance-set.9fb49ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/RadianceSet/img/radiance-set.png
// module id = 513
// module chunks = 0